import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="admin--stat--catalog"
export default class extends Controller {
  connect() {
    this.requestStat()
  }

  async requestStat() {
    const response = await get(this.url, { responseKind: 'json' })
    if (response.ok) {
      const json = await response.json
      this.renderPhrases(json['phrases'])
    } else {
      console.error(response.statusText)
    }
  }

  get url() {
    const catalogNumber = this.element.dataset['catalogNumber'];
    return `/admin/catalogs/${catalogNumber}/visit_search_phrases`;
  }

  renderPhrases(phrases) {
    if (phrases.length) {
      phrases.forEach((ph) => {
        const count = ph['count'];
        const phrase = ph['phrase'];
        const html = `<p>
            <img class='favicon' src='https://${phrase['favicon']}/favicon.ico'>
            <a class='phrase' href='${phrase['url']}'>${phrase['name']}</a>
            <span class='count'>${count}</span>
          </p>`;
        this.element.append(htmlToElems(html)[0]);
      })
    } else {
      this.element.innerHTML = 'ничего не найдено';
    }
  }
}
